import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'

const InputFieldUnlabelled = props => (
  <div
    className={classNames({
      'form-field': true,
      'simple-field': true,
      'has-error': props.hasError,
      'has-icon': Boolean(props.iconName),
      [props.theme]: true
    })}
  >
    {props.currency && <span className='currency'>{props.currency}</span>}
    <input
      type={props.type}
      autoComplete='off'
      autoFocus={props.autoFocus}
      className='form-input'
      id={props.id}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      value={props.value}
      onSubmit={props.onBlur}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      disabled={props.disabled ? 'disabled' : ''}
    />
    {props.note && <span className='note'>{props.note}</span>}
    {props.helperText && (
      <span className='helper-text'>{props.helperText}</span>
    )}
    {props.hasError && props.errorText && <span className='error-text'>{props.errorText}</span>}
    {props.iconName && <Icon name={props.iconName} />}
  </div>
)

InputFieldUnlabelled.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
  note: PropTypes.string,
  currency: PropTypes.string,
  theme: PropTypes.oneOf(['light-theme', 'dark-theme']),
  autoFocus: PropTypes.bool
}

InputFieldUnlabelled.defaultProps = {
  theme: 'light-theme',
  type: 'text',
  meta: {},
  input: {}
}

export default InputFieldUnlabelled



// WEBPACK FOOTER //
// ./src/ui/forms/input-field-unlabelled.js